import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;

  padding: 4px 8px;
  box-sizing: border-box;

  border-radius: 6px;
  border: 1px solid var(--border-neutral, #bbc1d3);
  background: var(--background-elevation-base, #fff);
`

export const SearchIconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 16px;
  height: 16px;
`

export const SearchIconImg = styled.img``

export const Input = styled.input`
  border: none;
  outline: none;

  flex: 1;
  padding: 0;

  color: var(--foreground-neutral, #14171f);

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */

  ::placeholder {
    color: var(--foreground-neutral-faded, #4d5874);
  }
`
